(function(){
'use strict';
if(window.__mbLuckyLemons)return;window.__mbLuckyLemons=true;
if(/\/(cart|checkout)/.test(location.pathname))return;
var PREVIEW=/[?&](growpopup|scratchpopup)=1/.test(location.search);
var FORCE=(location.search.match(/[?&]llwin=(bottles|cans|flowers|lemons)/)||[])[1]||null;
var KLAVIYO_COMPANY='WLfhcW',KLAVIYO_LIST='Yuzeb6';
var DELAY_MS=9000,SNOOZE_MS=1209600000;
var doneFlag=null,disTs=0,tabHidden=false;
try{doneFlag=localStorage.getItem('mbScratchDone');disTs=parseInt(localStorage.getItem('mbScratchDismissed')||'0',10)||0;}catch(e){}
try{tabHidden=sessionStorage.getItem('mbScratchTabHide')==='1';}catch(e){}
var suppressed=!!doneFlag||(disTs&&(Date.now()-disTs)<SNOOZE_MS);
var AID=null;
try{AID=localStorage.getItem('mbScratchAid');}catch(e){}
if(!AID){AID='mbs-'+Date.now().toString(36)+'-'+Math.random().toString(36).slice(2,10);try{localStorage.setItem('mbScratchAid',AID);}catch(e){}}
var IBASE=(function(){try{var s=(document.currentScript&&document.currentScript.src)||'';if(!s){var els=document.querySelectorAll('script[src*="mb-grow-popup"]');if(els.length)s=els[els.length-1].src;}return s?s.split('mb-grow-popup.js')[0]:'';}catch(e){return '';}})();
var IV='?v=3';
var ICON={bottle:IBASE+'mb-ll-bottle.png'+IV,can:IBASE+'mb-ll-can.png'+IV,flower:IBASE+'mb-ll-flower.png'+IV,lemon:IBASE+'mb-ll-lemon.png'+IV};
var PRIZES=[
{id:'bottles',sym:'bottle',w:80,name:'10% OFF',code:'LUCKY10',combo:'3 BOTTLES \u2014 WINNING COMBINATION'},
{id:'cans',sym:'can',w:10,name:'$15 STORE CREDIT',code:'LUCKY15',combo:'3 WATERING CANS \u2014 WINNING COMBINATION'},
{id:'flowers',sym:'flower',w:9,name:'FREE SHIPPING',code:'LUCKYSHIP',combo:'3 FLOWERS \u2014 WINNING COMBINATION'},
{id:'lemons',sym:'lemon',w:1,name:'20% OFF SITEWIDE',code:'LUCKY20',combo:'3 LEMONS \u2014 WINNING COMBINATION'}];
var SHOP_URL='?redirect=/products/medibud-medigrow-bundle';
var opened=false,completed=false,knownEmail=null,root=null,modal=null,tab=null;
var state='optin',grid=[],prize=null,revealed=[],canvases={},discovering=false;

/* 14 Sep 2026: only send events to Klaviyo once we have an email — stops empty anonymous profiles */
function kTrack(name,props,pprops){
if(!knownEmail)return;
try{var idAttrs={email:knownEmail};
if(pprops)idAttrs.properties=pprops;
fetch('https://a.klaviyo.com/client/events/?company_id='+KLAVIYO_COMPANY,{method:'POST',keepalive:true,headers:{'Content-Type':'application/json','revision':'2025-01-15'},body:JSON.stringify({data:{type:'event',attributes:{properties:props||{},metric:{data:{type:'metric',attributes:{name:name}}},profile:{data:{type:'profile',attributes:idAttrs}}}}})}).catch(function(){});}catch(e){}}
function subscribe(email,props){
try{fetch('https://a.klaviyo.com/client/subscriptions/?company_id='+KLAVIYO_COMPANY,{method:'POST',keepalive:true,headers:{'Content-Type':'application/json','revision':'2025-01-15'},body:JSON.stringify({data:{type:'subscription',attributes:{profile:{data:{type:'profile',attributes:{email:email,properties:props||{}}}}},relationships:{list:{data:{type:'list',id:KLAVIYO_LIST}}}}})}).catch(function(){});}catch(e){}}

function pickPrize(){
if(FORCE){var f=null;for(var i=0;i<4;i++)if(PRIZES[i].id===FORCE)f=PRIZES[i];if(f)return f;}
var r=Math.random()*100;
for(var j=0;j<PRIZES.length;j++){if(r<PRIZES[j].w)return PRIZES[j];r-=PRIZES[j].w;}
return PRIZES[0];}
function buildGrid(p){
var cells=[],pool=[],i,j,t;
for(i=0;i<3;i++)cells.push({sym:p.sym,win:true});
for(i=0;i<PRIZES.length;i++)if(PRIZES[i].sym!==p.sym){pool.push(PRIZES[i].sym);pool.push(PRIZES[i].sym);}
for(i=pool.length-1;i>0;i--){j=Math.floor(Math.random()*(i+1));t=pool[i];pool[i]=pool[j];pool[j]=t;}
while(cells.length<9)cells.push({sym:pool.pop(),win:false});
for(i=cells.length-1;i>0;i--){j=Math.floor(Math.random()*(i+1));t=cells[i];cells[i]=cells[j];cells[j]=t;}
return cells;}

function headHTML(inner){return '<div class="ll-head">'+inner+'</div>';}
function optinHTML(){
return headHTML(
'<div class="ll-kicker">Medibud presents</div>'+
'<h1 class="ll-title">Lucky<br>Lemons</h1>'+
'<img src="'+ICON.lemon+'" alt="" class="ll-headlemon">'+
'<div class="ll-pill">Everyone wins!</div>'+
'<p class="ll-subtitle">Scratch to reveal your instant prize.</p>')+
'<div class="ll-body">'+
'<div class="ll-plabel">Four prizes hiding in the card</div>'+
'<div class="ll-pstrip">'+
'<div class="ll-pchip"><img src="'+ICON.bottle+'" alt=""><strong>10% off</strong><span>Sitewide</span></div>'+
'<div class="ll-pchip"><img src="'+ICON.can+'" alt=""><strong>$15</strong><span>Store credit</span></div>'+
'<div class="ll-pchip"><img src="'+ICON.flower+'" alt=""><strong>Free</strong><span>Shipping</span></div>'+
'<div class="ll-pchip"><img src="'+ICON.lemon+'" alt=""><strong>20% off</strong><span>Sitewide</span></div>'+
'</div>'+
'<div class="ll-optin">'+
'<div class="ll-otitle">Enter your email to play</div>'+
'<div class="ll-ewrap">'+
'<svg viewBox="0 0 24 24" width="19" height="19" fill="none" stroke="#6D766E" stroke-width="1.8"><rect x="3" y="5" width="18" height="14" rx="2"></rect><path d="M3 7l9 6 9-6"></path></svg>'+
'<input id="llEm" type="email" aria-label="Email address" autocomplete="email" placeholder="Enter your email address" class="ll-email">'+
'</div>'+
'<div id="llErr" class="ll-error" style="display:none" role="alert">Please enter a valid email address.</div>'+
'<button id="llGo" type="button" class="ll-cta">Let\u2019s get lucky!</button>'+
'</div>'+
'<div class="ll-note"><span class="ll-coin"></span><span>Your scratchie unlocks instantly after sign-up.</span></div>'+
'<p class="ll-privacy">By entering your email, you\u2019ll receive exclusive Medibud offers &amp; gardening tips. Unsubscribe anytime.</p>'+
'</div>';}

function gameHTML(){
var tiles='';
for(var i=0;i<9;i++){
tiles+='<div class="ll-tile" id="llTile'+i+'">'+
'<div role="img" aria-label="Hidden symbol" class="ll-ticon" style="background-image:url(\''+ICON[grid[i].sym]+'\')"></div>'+
'<canvas width="200" height="200" data-i="'+i+'" aria-label="Scratch tile '+(i+1)+'"></canvas>'+
'</div>';}
return headHTML(
'<div class="ll-kicker">Medibud \u00b7 Lucky Lemons</div>'+
'<div id="llGameHead"><h2 class="ll-title ll-game">Scratch &amp; win!</h2>'+
'<p id="llSub" class="ll-subtitle">Scratch all 9 spots to reveal your prize.</p></div>')+
'<div class="ll-body">'+
'<div id="llTrkWrap"><div class="ll-plabel">Match 3 to win</div>'+
'<div id="llTrk" class="ll-tracker"></div></div>'+
'<div class="ll-zone"><div class="ll-grid">'+tiles+'</div></div>'+
'<div id="llCombo" class="ll-combo" style="display:none"></div>'+
'<div id="llProg" class="ll-prog">'+
'<div class="ll-pcount">SCRATCHED <span id="llCount">0</span> / 9</div>'+
'<div class="ll-pbar"><div id="llFill" class="ll-pfill" style="width:0%"></div></div>'+
'<div class="ll-pcopy">Your prize is waiting...</div>'+
'<button id="llRevealAll" type="button" class="ll-reveal">Can\u2019t scratch? Reveal my card</button>'+
'</div>'+
'<div id="llWin"></div>'+
'</div>';}

function renderTracker(){
var el=document.getElementById('llTrk');if(!el)return;
var counts={bottle:0,can:0,flower:0,lemon:0};
for(var i=0;i<9;i++)if(revealed[i])counts[grid[i].sym]++;
var defs=[{sym:'bottle',rest:'= 10% off'},{sym:'can',rest:'= $15'},{sym:'flower',rest:'= shipping'},{sym:'lemon',rest:'= 20% off'}];
var html='';
for(var d=0;d<4;d++){
var t=defs[d],found=Math.min(counts[t.sym]||0,3),full=found>=3;
var cls='ll-tcard '+(full?'ll-full':(found>0?'ll-some':'ll-none'));
var pips='';
for(var k=0;k<3;k++)pips+='<span class="ll-pip'+(k<found?' ll-hit':'')+'"></span>';
html+='<div class="'+cls+'" aria-label="'+t.sym+': '+found+' of 3 found">'+
'<img src="'+ICON[t.sym]+'" alt="">'+
'<span class="ll-rule">\u00d73 <i>'+t.rest+'</i></span>'+
'<div class="ll-pips">'+pips+'</div>'+
'</div>';}
el.innerHTML=html;}

function drawCoat(cv){
var ctx=cv.getContext('2d'),w=cv.width,h=cv.height;
ctx.globalCompositeOperation='source-over';ctx.clearRect(0,0,w,h);
var g=ctx.createLinearGradient(0,0,w,h);
g.addColorStop(0,'#ecece8');g.addColorStop(.24,'#b5b6b1');g.addColorStop(.5,'#deded9');g.addColorStop(.72,'#a8aaa5');g.addColorStop(1,'#d7d8d3');
ctx.fillStyle=g;ctx.fillRect(0,0,w,h);
for(var i=0;i<180;i++){ctx.fillStyle=Math.random()>0.5?'rgba(255,255,255,0.30)':'rgba(75,78,73,0.16)';ctx.fillRect(Math.random()*w,Math.random()*h,Math.random()*2.4+1,1.2);}
ctx.strokeStyle='rgba(255,255,255,0.22)';ctx.lineWidth=2;
for(var y=-w;y<h*2;y+=22){ctx.beginPath();ctx.moveTo(0,y);ctx.lineTo(w,y+w);ctx.stroke();}
ctx.fillStyle='#575A55';ctx.textAlign='center';ctx.textBaseline='middle';
ctx.font='800 20px Hanken Grotesk, sans-serif';
ctx.fillText('SCRATCH',w/2,h/2-11);ctx.fillText('ME!',w/2,h/2+12);}

function initTile(cv,i){
canvases[i]=cv;drawCoat(cv);
var down=false,moves=0;
function scratch(e){
if(revealed[i]||state!=='scratch')return;
var r=cv.getBoundingClientRect();
var x=(e.clientX-r.left)*cv.width/r.width,y=(e.clientY-r.top)*cv.height/r.height;
var ctx=cv.getContext('2d');
ctx.globalCompositeOperation='destination-out';
ctx.beginPath();ctx.arc(x,y,26,0,7);ctx.fill();
moves++;
if(moves%4===0)checkErased(cv,i);}
cv.addEventListener('pointerdown',function(e){down=true;e.preventDefault();try{cv.setPointerCapture(e.pointerId);}catch(x){}scratch(e);});
cv.addEventListener('pointermove',function(e){if(down){e.preventDefault();scratch(e);}});
function up(){if(down){down=false;checkErased(cv,i);}}
cv.addEventListener('pointerup',up);cv.addEventListener('pointercancel',up);}
function checkErased(cv,i){
if(revealed[i])return;
try{var d=cv.getContext('2d').getImageData(0,0,cv.width,cv.height).data;
var clear=0,total=0;
for(var p=3;p<d.length;p+=64){total++;if(d[p]<40)clear++;}
if(clear/total>0.35)revealTile(i);}catch(e){}}
function wipeTile(i){var cv=canvases[i];if(cv){cv.getContext('2d').clearRect(0,0,cv.width,cv.height);cv.style.opacity='0';cv.style.pointerEvents='none';}}
function revealTile(i){
if(revealed[i])return;
revealed[i]=1;wipeTile(i);
var ic=document.querySelector('#llTile'+i+' .ll-ticon');
if(ic)ic.setAttribute('aria-label',grid[i].sym);
renderTracker();
var n=0;for(var k=0;k<9;k++)if(revealed[k])n++;
var c=document.getElementById('llCount'),f=document.getElementById('llFill');
if(c)c.textContent=n;if(f)f.style.width=(n/9*100)+'%';
if(n===9)startDiscovery();}
function revealAllTiles(){for(var i=0;i<9;i++){if(!revealed[i]){revealed[i]=1;wipeTile(i);}}renderTracker();var c=document.getElementById('llCount'),f=document.getElementById('llFill');if(c)c.textContent='9';if(f)f.style.width='100%';startDiscovery();}

function startDiscovery(){
if(discovering)return;discovering=true;
setTimeout(function(){
if(!root)return;
state='discover';
var sub=document.getElementById('llSub');if(sub)sub.textContent='Finding your winning combination...';
var prog=document.getElementById('llProg');if(prog)prog.style.display='none';
for(var i=0;i<9;i++)if(!grid[i].win){var tl=document.getElementById('llTile'+i);if(tl)tl.classList.add('ll-dim');}
var winners=[];
for(var j=0;j<9;j++)if(grid[j].win)winners.push(j);
winners.forEach(function(idx,k){
setTimeout(function(){
if(!root)return;
var tl=document.getElementById('llTile'+idx);if(tl)tl.classList.add('ll-hi');
if(k===0){var cb=document.getElementById('llCombo');if(cb){cb.textContent=prize.combo;cb.style.display='inline-flex';}}
},350+k*300);});
setTimeout(finishPrize,350+winners.length*300+700);
},750);}

function finishPrize(){
if(!root)return;
state='done';
kTrack('Scratch Popup Ticket Scratched',{combo:prize.combo,gift_won:prize.code},{scratch_combo:prize.combo,gift_won:prize.code,signup_source:'Lucky Lemons Popup'});
var gh=document.getElementById('llGameHead');
if(gh)gh.innerHTML='<h2 class="ll-title ll-game" style="color:#103D25">Congrats!</h2><div class="ll-pill">You won</div>';
var tw=document.getElementById('llTrkWrap');if(tw)tw.style.display='none';
var win=document.getElementById('llWin');
win.innerHTML='<div class="ll-winwrap">'+
'<div class="ll-badge">'+prize.name+'</div>'+
'<p class="ll-wincopy">Your garden just got a little greener!</p>'+
'<div class="ll-clabel">YOUR CODE</div>'+
'<button id="llCode" type="button" class="ll-code" aria-label="Copy code '+prize.code+'">'+prize.code+' <span id="llCopyLbl">COPY</span></button>'+
'<button id="llShop" type="button" class="ll-shop">Shop Medibud \u2192</button>'+
'<p class="ll-sent">Your code has also been sent to your email.</p>'+
'</div>';
document.getElementById('llCode').addEventListener('click',function(){
try{if(navigator.clipboard)navigator.clipboard.writeText(prize.code).catch(function(){});}catch(e){}
var l=document.getElementById('llCopyLbl');if(l){l.textContent='\u2713 COPIED';setTimeout(function(){if(l)l.textContent='COPY';},1800);}});
document.getElementById('llShop').addEventListener('click',function(){
kTrack('Scratch Popup Gift Clicked',{gift_won:prize.code},{gift_won:prize.code});
setTimeout(function(){location.href='/discount/'+prize.code+SHOP_URL;},150);});
try{win.scrollIntoView({behavior:'smooth',block:'nearest'});}catch(e){}}

function renderGame(){
prize=pickPrize();grid=buildGrid(prize);
revealed=[0,0,0,0,0,0,0,0,0];canvases={};discovering=false;state='scratch';
var view=document.getElementById('llView');
view.innerHTML=gameHTML();
renderTracker();
var cvs=view.querySelectorAll('canvas');
for(var i=0;i<cvs.length;i++)initTile(cvs[i],parseInt(cvs[i].getAttribute('data-i'),10));
document.getElementById('llRevealAll').addEventListener('click',revealAllTiles);}

function submitEmail(){
var em=document.getElementById('llEm'),err=document.getElementById('llErr'),go=document.getElementById('llGo');
var v=(em.value||'').trim();
if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v)){err.style.display='block';em.classList.add('ll-bad');em.focus();return;}
err.style.display='none';em.classList.remove('ll-bad');
go.disabled=true;go.textContent='Unlocking your card...';
knownEmail=v;completed=true;
try{localStorage.setItem('mbScratchDone','1');}catch(e){}
removeTab();
subscribe(v,{signup_source:'Lucky Lemons Popup'});
kTrack('Scratch Popup Email Submitted',{},{signup_source:'Lucky Lemons Popup'});
setTimeout(renderGame,650);}

function removeTab(){if(tab&&tab.parentNode)tab.parentNode.removeChild(tab);tab=null;}
function hideTab(){if(tab)tab.style.display='none';}
function showTab(){
if(completed||doneFlag||tabHidden)return;
if(tab){tab.style.display='';return;}
tab=document.createElement('div');tab.className='ll-tabwrap';
tab.innerHTML='<button class="ll-tab" type="button" aria-label="Open the Lucky Lemons scratch and win popup">Scratch &amp; win a gift</button><button class="ll-tabx" type="button" aria-label="Hide tab">&times;</button>';
document.body.appendChild(tab);
tab.querySelector('.ll-tab').addEventListener('click',function(){opened=false;openPopup('tab');});
tab.querySelector('.ll-tabx').addEventListener('click',function(){tabHidden=true;try{sessionStorage.setItem('mbScratchTabHide','1');}catch(e){}removeTab();});}

function closePopup(){
if(!root)return;
if(!completed)kTrack('Scratch Popup Dismissed',{stage:state});
try{if(!completed)localStorage.setItem('mbScratchDismissed',String(Date.now()));}catch(e){}
root.classList.remove('ll-on');document.body.classList.remove('ll-lock');
var r=root;root=null;modal=null;
setTimeout(function(){if(r&&r.parentNode)r.parentNode.removeChild(r);},300);
document.removeEventListener('keydown',onKey);
if(!completed)showTab();}
function onKey(e){if(e.key==='Escape')closePopup();}

function openPopup(src){
if(opened||root)return;opened=true;
hideTab();
state='optin';
root=document.createElement('div');root.className='ll-overlay';
root.innerHTML='<div role="dialog" aria-modal="true" aria-label="Lucky Lemons instant win game" class="ll-modal">'+
'<button class="ll-close" aria-label="Close" type="button">\u2715</button>'+
'<div id="llView">'+optinHTML()+'</div>'+
'</div>';
document.body.appendChild(root);document.body.classList.add('ll-lock');
modal=root.querySelector('.ll-modal');
root.querySelector('.ll-close').addEventListener('click',closePopup);
root.addEventListener('click',function(e){if(e.target===root)closePopup();});
document.addEventListener('keydown',onKey);
document.getElementById('llGo').addEventListener('click',submitEmail);
var em=document.getElementById('llEm');
em.addEventListener('input',function(){document.getElementById('llErr').style.display='none';em.classList.remove('ll-bad');});
em.addEventListener('keydown',function(e){if(e.key==='Enter'){e.preventDefault();submitEmail();}});
kTrack('Scratch Popup Viewed',{trigger:src||'unknown'});
requestAnimationFrame(function(){requestAnimationFrame(function(){if(root)root.classList.add('ll-on');});});}

window.mbScratchOpen=function(){opened=false;openPopup('manual');};
window.mbGrowOpen=window.mbScratchOpen;

function boot(){
if(PREVIEW){openPopup('preview');return;}
if(doneFlag)return;
showTab();
if(suppressed)return;
/* 8 Sep 2026: never open over an open cart drawer. Wait until it is closed, then show. */
function cartOpen(){var w=document.querySelector('.mbd-wrap');return !!(w&&!w.hidden&&w.classList.contains('is-open'));}
function timerOpen(){if(opened||root)return;if(cartOpen()){setTimeout(timerOpen,4000);return;}openPopup('timer');}
setTimeout(timerOpen,DELAY_MS);
if(window.matchMedia&&matchMedia('(hover: hover) and (pointer: fine)').matches){
document.addEventListener('mouseout',function onOut(e){if(opened)return;if(!e.relatedTarget&&e.clientY<=0){document.removeEventListener('mouseout',onOut);openPopup('exit');}});}
}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',boot);}else{boot();}
})();

/* Launch tweaks: illustrated before/after goal tiles on the home page */
(function(){
'use strict';
function base(){try{var els=document.querySelectorAll('script[src*="mb-grow-popup"]');var s=els.length?els[els.length-1].src:'';return s?s.split('mb-grow-popup.js')[0]:'';}catch(e){return '';}}
function setTile(frag,file,B){
var a=document.querySelector('.mh-tile[href*="'+frag+'"]');if(!a)return;
var img=a.querySelector('img');
if(!img){img=document.createElement('img');img.alt='';img.loading='lazy';a.insertBefore(img,a.firstChild);}
img.src=B+file+'?v=1';
img.style.opacity='0.85';}
function run(){
if(!document.querySelector('.mh-tiles'))return;
var B=base();if(!B)return;
setTile('greener-lawn','mb-goal-lawn.svg',B);
setTile('blooms-and-fruit','mb-goal-bloom.svg',B);
setTile('happy-indoor-plants','mb-goal-indoor.svg',B);
setTile('whole-garden','mb-goal-garden.svg',B);}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',run);}else{run();}
})();